import React, { useEffect } from "react";
import Premium from "_c/Premium";
import { Header, Content } from "_c/Modals";
import { analyticsAction } from "@/utils/analytics";
import { useTranslation } from "react-i18next";

const PremiumModalMain = (props) => {
  const { t, ready } = useTranslation(["common"], { useSuspense: false });
  useEffect(() => {
    analyticsAction({
      category: "common",
      action: "premium_show",
    });
  }, []);
  if (!ready) return null;
  return (
    <>
      <Header onClick={props.onClose}>{t("common:close")}</Header>
      <Content>
        <Premium
          css={`
            margin-top: 0;
          `}
          hideFeaturesList
          {...props}
        />
      </Content>
    </>
  );
};

export default PremiumModalMain;
